import { Section } from "./State/Routine/types";

export function getSectionTitle(
  section: Pick<Section, "title" | "assignedTeam">
) {
  if (section.title !== "" && section.title !== null) {
    return section.title;
  }
  if (section.assignedTeam) {
    return section.assignedTeam.name;
  }
  return "";
}
